import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Alert } from 'jbc-front/components/icons';
import { EMPLOYEE_BONUS_EDIT } from 'src/constants/EndpointUrls';
import { redirectTo, detailUrlWithQueries, getIdsFromArr } from 'src/utils/Http';
import { getOptionLabel, isInTargetDateRange } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';
import MemoList from 'src/features/Memos';
import SortableTh from 'src/components/SortableTh';
import {
  getEmployeeBonusList,
  getEmployeeBonusQueries,
  getSelectingClientBonus
} from 'src/reducers/employees/employeeBonus';
import { FORM_NAME_BONUSES_SEARCH } from 'src/reducers/searchForm';
import { getSelectOptions } from 'src/reducers/selectOptions';
import styles from './EmployeeBonusTable.scss';

const EmployeeBonusRow = ({ onClick, employeeBonusItem, clientEmploymentTypes, selectingClientBonus }) => {
  const { applyForTimeFrom, applyForTimeTo } = selectingClientBonus || {};
  const { t, i18n } = useTranslation();
  const joinedOnStyle = isInTargetDateRange(applyForTimeFrom, applyForTimeTo, employeeBonusItem.joinedOn) ? (
    <span className={styles.icon}>
      <Alert size={16} />
      <span className={styles.baloon}>{t('features.EmployeeBonus.components.EmployeeBonusTable.employees_who_started_during_the_bonus_calculation_period')}</span>
    </span>
  ) : (
    ''
  );
  const resignedOnStyle = isInTargetDateRange(applyForTimeFrom, applyForTimeTo, employeeBonusItem.resignedOn) ? (
    <span className={styles.icon}>
      <Alert size={16} />
      <span className={styles.baloon}>{t('features.EmployeeBonus.components.EmployeeBonusTable.employees_who_retired_during_the_bonus_calculation_period')}</span>
    </span>
  ) : (
    ''
  );

  return (
    <tr onClick={onClick} className="table-hover">
      <td>
        <MemoList employeeId={employeeBonusItem.employeeId} />
      </td>
      <td>{employeeBonusItem.staffCode}</td>
      <td>{employeeBonusItem.employeeFullName}</td>
      <td>{getOptionLabel(employeeBonusItem.employmentTypeId)(clientEmploymentTypes)}</td>
      <td>
        <span className={joinedOnStyle ? styles.dateWithIcon : styles.date}>
          {formatDate(employeeBonusItem.joinedOn)}
          {joinedOnStyle}
        </span>
      </td>
      <td>
        <span className={resignedOnStyle ? styles.dateWithIcon : styles.date}>
          {formatDate(employeeBonusItem.resignedOn)}
          {resignedOnStyle}
        </span>
      </td>
    </tr>
  );
};

const EmployeeBonusTable = props => {
  const { t, i18n } = useTranslation();
  const { employeeBonusList, queries, selectingClientBonus, clientEmploymentTypes } = props;
  let onClickFlag = false;

  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list">
        <thead>
          <tr>
            <th>{t('features.EmployeeBonus.components.EmployeeBonusTable.note')}</th>
            <SortableTh field="staffCode" globalClassName="m-table-list-staffcode" formName={FORM_NAME_BONUSES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.staff_code')}
            </SortableTh>
            <SortableTh field="name" formName={FORM_NAME_BONUSES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.name')}
            </SortableTh>
            <SortableTh field="employmentTypeId" formName={FORM_NAME_BONUSES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.employment_type')}
            </SortableTh>
            <SortableTh field="joinedOn" formName={FORM_NAME_BONUSES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.start_date')}
            </SortableTh>
            <SortableTh field="resignedOn" formName={FORM_NAME_BONUSES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.retire_date')}
            </SortableTh>
          </tr>
        </thead>
        <tbody>
          {employeeBonusList &&
            employeeBonusList.length > 0 &&
            employeeBonusList.map(item => (
              <EmployeeBonusRow
                onClick={() => {
                  if (!onClickFlag) {
                    onClickFlag = true;
                    redirectTo(
                      detailUrlWithQueries(item.id, queries, EMPLOYEE_BONUS_EDIT, getIdsFromArr(employeeBonusList))
                    );
                  }
                }}
                key={item.id}
                employeeBonusItem={item}
                selectingClientBonus={selectingClientBonus}
                clientEmploymentTypes={clientEmploymentTypes}
              />
            ))}

          {(!employeeBonusList || employeeBonusList.length === 0) && (
            <tr>
              <td colSpan={6}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default connect(state => ({
  employeeBonusList: getEmployeeBonusList(state),
  queries: getEmployeeBonusQueries(state),
  selectingClientBonus: getSelectingClientBonus(state),
  clientEmploymentTypes: getSelectOptions(state, 'connectedEmploymentTypes')
}))(EmployeeBonusTable);
